const progressUpdate = () => {
  if (!document.querySelector('.post-info__progress')) return false;
  document.querySelector('.post-info__progress').style.width =
    document.querySelector('.post-info__progress').getBoundingClientRect().top > 0
    ? ( ( window.scrollY / ( document.body.scrollHeight - window.innerHeight ) ) * 100 ).toFixed(2) + '%'
    : 0;
}

const progressStickyClass = () => {
  if (!document.querySelector('.post-info__progress')) return false;
  const {top, height} = document.querySelector('.post-info').previousElementSibling.getBoundingClientRect();
  
  document.querySelector('.post-info').classList[top + height <= 0 ? 'add' : 'remove']('post-info--sticky');
}

const progressBar = () => {
  progressStickyClass();
  progressUpdate();
}

['DOMContentLoaded', 'scroll'].map(event => document.addEventListener(event, progressBar, {passive: true}));

